<template>
    <ul>
        <router-link @click="$emit('closeMenu')"  :to="{ name: 'Programme' }">
            <li>Programme</li>
        </router-link>
        <a tabindex="0" @click="menuOpenClose('themes')" @keypress.enter="menuOpenClose('themes')">
            <li>Themes</li>
        </a>
        <a tabindex="0" @click="menuOpenClose('session-format')" @keypress.enter="menuOpenClose('session-format')"> <li>Session formats</li></a>
        <a tabindex="0" @click="menuOpenClose('keynote')" @keypress.enter="menuOpenClose('keynote')"><li>Keynote</li></a>
        <a tabindex="0" @click="menuOpenClose('key-dates')" @keypress.enter="menuOpenClose('key-dates')"><li>Key dates</li></a>
        <a tabindex="0" @click="menuOpenClose('location')" @keypress.enter="menuOpenClose('location')"><li>Location</li></a>
    </ul>
   
</template>

<script setup>

    import { onMounted } from 'vue'
    import { useRouter, useRoute } from 'vue-router'

    const emits = defineEmits(["closeMenu"])
    const router = useRouter()
    const route = useRoute()

    onMounted(() => {
        if(route.query.section ===  'session format') {
            menuOpenClose('session-format')
        }
    })

    const menuOpenClose = async (anchor) => {
        await router.push({path: '/'})
        document.getElementById(anchor).scrollIntoView({behavior: "smooth"})
        emits('closeMenu')
    }

</script>
